import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';
import { AtlParagraphPlaceholderProps } from './placeholders.props';

import * as PlaceholderTags from './placeholders.tagnames';

@customElement(PlaceholderTags.Paragraph)
export class AtlParagraphPlaceholder extends LitElement implements AtlParagraphPlaceholderProps {

    declare bigLineHeight?: boolean | undefined;
    declare sentences: number;

    static properties = {
        bigLineHeight: { attribute: 'big-line-height', type: Boolean },
        sentences: { type: Number }
    }

    constructor() {
        super();
        this.sentences = 1;
    }

    static styles = [
        ...getGlobalStyleSheets()
    ];   

    renderSentences() {
        const sentences = [];
        for (let i = 0; i < this.sentences; i++) {
            sentences.push(html`<atlantis-span-placeholder size="Medium" glow></atlantis-span-placeholder>`);
            sentences.push(html`<atlantis-span-placeholder size="ExtraLarge" glow></atlantis-span-placeholder>`);
            sentences.push(html`<atlantis-span-placeholder size="Smaller" glow></atlantis-span-placeholder>`);
            sentences.push(html`<atlantis-span-placeholder size="Large" glow></atlantis-span-placeholder>`);
            sentences.push(html`<atlantis-span-placeholder size="Medium" glow></atlantis-span-placeholder>`);
            sentences.push(html`<atlantis-span-placeholder size="Smaller" glow></atlantis-span-placeholder>`);
            sentences.push(html`<atlantis-span-placeholder size="Larger" glow></atlantis-span-placeholder>`);
            sentences.push(html`<atlantis-span-placeholder size="Large" glow></atlantis-span-placeholder>`);
            sentences.push(html`<atlantis-span-placeholder size="ExtraSmall" glow></atlantis-span-placeholder>`);
        }
        return sentences;
    }

    render() {
        const classes = this.bigLineHeight ? "lh-lg" : "lh-md";
        return html`<p class="${classes}">${this.renderSentences()}</p>`;
    }
}